import React from "react";
import ProductionCenter from "../ProductionCenter/ProductionCenter";

export default function KdsTabs() {
    return <ProductionCenter detailedCards />;
}
